'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default function () {
    return {
        restrict: 'A',
        template: require('../../../view/table.html'),
        transclude: true,
        scope: {
            selectedItem: '=?myValue',
            items: '=?myItems',
            type: '@myType',
            filters: '=?myFilters',
            ok: '=?myOk',
            isPaging: '=myPagination',
            isSearch: '=mySearching',
            isFilter: '=myFilter',
            edit: '=?edit'
        },
        controllerAs: 'vm',
        controller: ['$scope', '$utils', 'StatusService', 'Notification', '$security', 'OkvedService',
            function ($scope, $utils, StatusService, Notification, $security, OkvedService) {

                $scope.dblClick = dblClick;
                $scope.select = select;
                $scope.isSelect = isSelect;
                $scope.getItems = getItems;
                $scope.getValue = $utils.getValue;
                $scope.getStatusDisplayName = StatusService.getDisplayName;

                // инициализация
                init();

                // region Function

                function init() {

                    $scope.columns = [{
                        name: "Код ОКВЭД",
                        data: "code"
                    }, {
                        name: "Наименование вида деятельности по ОКВЭД",
                        data: "name"
                    }];

                    $scope.searching = {
                        isSearch: $scope.isSearch,
                        filter: null
                    };

                    $scope.pagination = {
                        isPaging: $scope.isPaging,
                        page: 1,
                        size: $scope.isPaging ? 10 : null,
                        totalPages: null,
                        totalItems: null
                    };

                    // тулбокс таблицы
                    $scope.toolbox = {
                        // кнопки на панели управления
                        buttons: {
                            // создание
                            create: {
                                show: () => $scope.edit && $security.isAllowWrite('/orgs'),
                                click: () => OkvedService.select().result.then((data) => {
                                    if (!$scope.items.some(item => item.id == data.id)) {
                                        $scope.items.push(data);
                                    }
                                }),
                                disabled: () => false,
                            },
                            // удаление
                            remove: {
                                show: () => $scope.edit && isSelected() && $security.isAllowWrite('/orgs'),
                                click: (item) => $scope.items.splice($scope.items.indexOf(item), 1),
                                disabled: () => $scope.selectedItem == null || $scope.selectedItem.id == null,
                            },
                        }
                    };
                }

                /**
                 * Получение всех записей
                 * @returns {*}
                 */
                function getItems() {
                    return $scope.items;
                }

                /**
                 * Выбран ли элемент!
                 * @param item проверяемый элемент
                 * @returns bool
                 */
                function isSelect(item) {
                    return equals(getSelected(), item);
                }

                /**
                 * Выбрать элемент
                 * @param item выбираемый элемент
                 */
                function select(item) {
                    if (!$scope.isSelect(item)) {
                        $scope.selectedItem = angular.copy(item);
                    } else {
                        $scope.selectedItem = angular.copy({});
                    }
                }

                /**
                 * Двойное нажатие на запись в таблице
                 * @param item данные записи
                 */
                function dblClick(item) {
                    switch ($scope.type) {
                        case 'table' :
                            $scope.toolbox.buttons.edit.click(item);
                            break;
                        case 'select' :
                            $scope.ok();
                            break;
                    }
                }

                /**
                 * Выбрана ли запись
                 * @returns {boolean}
                 */
                function isSelected() {
                    return $scope.selectedItem != null && !angular.equals($scope.selectedItem, {});
                }

                /**
                 * Проверка элементов на равенство
                 * @param i1
                 * @param i2
                 * @returns {*}
                 */
                function equals(i1, i2) {
                    if (i1 == i2) {
                        return true;
                    }
                    if (i1 != null && i2 != null) {
                        return angular.equals(i1.id, i2.id);
                    }
                    return false;
                }

                /**
                 * Получить выбранный элемент
                 * @returns {{}|*}
                 */
                function getSelected() {
                    return $scope.selectedItem;
                }

                // endregion

            }]
    };
}
